module.exports = __webpack_public_path__ + "static/media/IT-MOBILE.67ac782e.jpg";